import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { MpApprovalPage } from '@/features/marketPromotion/pages/MpApprovalPage';
import { mpApprovalSearchSchema } from '@/features/marketPromotion/types/marketPromotion.types';

export const Route = createFileRoute('/_auth/market-promotion/approvals')({
  validateSearch: mpApprovalSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="Market Promotion Approval">
      <Suspense fallback={<PageLoader />}>
        <MpApprovalPage routeId="approvals" title="Market Promotion Approval" showCall={false} />
      </Suspense>
    </ErrorBoundary>
  ),
});
